import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { StarBackground } from './ui/StarBackground';
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-169">
      {/* Backgrounds */}
      <div className="absolute inset-0 bg-[#050510]" data-id="element-170">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-purple-900/20 rounded-full blur-[120px] animate-pulse-glow" data-id="element-171" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-pink-900/10 rounded-full blur-[100px]" data-id="element-172" />
      </div>

      <StarBackground data-id="element-173" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-175">
          <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className="h-28 md:h-36 lg:h-44 w-auto mx-auto object-contain drop-shadow-[0_0_30px_rgba(124,58,237,0.5)]" data-id="element-176" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-8" data-id="element-177">
          <Sparkles className="w-4 h-4 text-yellow-400" data-id="element-178" />
          <span className="text-sm font-medium text-gray-300 tracking-wide" data-id="element-179">
            Expertos en hacer crecer restaurantes
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold font-orbitron leading-tight mb-6" data-id="element-180">
          Más clientes para tu restaurante con un menú digital{' '}
          <br className="hidden md:block" data-id="element-181" />
          <span className="text-gradient-cosmic glow-text" data-id="element-182">que convierte</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-183">
          Creamos el sistema que hace que tus visitas de Instagram y Facebook se
          conviertan en reservaciones y pedidos por WhatsApp. Listo en 5 días.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-184">
          <a href="#precios" className="group relative px-8 py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-size-200 animate-bg-pan rounded-full font-bold text-white shadow-[0_0_30px_rgba(124,58,237,0.5)] hover:shadow-[0_0_50px_rgba(217,70,239,0.7)] transition-all duration-300 overflow-hidden" data-id="element-185">
            <span className="relative z-10 flex items-center gap-2" data-id="element-186">
              Quiero Mi Menú Digital
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-187" />
            </span>
            <div className="absolute inset-0 bg-white/20 group-hover:opacity-100 opacity-0 transition-opacity duration-300" data-id="element-188" />
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="mt-6 text-sm text-gray-500" data-id="element-189">
          Consulta gratuita • Entrega en 5 días • Sin compromiso
        </motion.p>
      </div>

      {/* Floating Elements Decoration */}
      <div className="absolute top-1/4 left-10 w-20 h-20 border border-purple-500/30 rounded-full animate-float hidden lg:block" data-id="element-190" />
      <div className="absolute bottom-1/4 right-10 w-32 h-32 border border-pink-500/20 rounded-full animate-float hidden lg:block" style={{
      animationDelay: '1s'
    }} data-id="element-191" />
    </section>;
}